import React from 'react';
import styles from './InputGuide.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const InputGuide = ({text, isError, defaultHide, className}) => {
  return (
    <p className={`${cx(defaultHide ? 'InputGuide--hide' : 'InputGuide', isError && 'InputGuide--error')} ${className}`}>{text}</p>
  );
};

export default InputGuide;